"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAmount = void 0;
const tslib_1 = require("tslib");
const spl_token_1 = require("@solana/spl-token");
const token_math_1 = require("@ubeswap/token-math");
const bn_js_1 = (0, tslib_1.__importDefault)(require("bn.js"));
class TokenAmount extends token_math_1.TokenAmount {
    // amount _must_ be raw, i.e. in the native representation
    constructor(token, amount) {
        super(token, amount);
        (0, token_math_1.validateU64)(this.raw);
    }
    /**
     * Parses a token amount from a decimal representation.
     * @param token
     * @param uiAmount
     * @returns
     */
    static parse(token, uiAmount) {
        const prev = token_math_1.TokenAmount.parseFromString(token, uiAmount);
        return new TokenAmount(token, prev.raw);
    }
    add(other) {
        const result = super.add(other);
        return new TokenAmount(this.token, result.raw);
    }
    subtract(other) {
        const result = super.subtract(other);
        return new TokenAmount(this.token, result.raw);
    }
    multiplyBy(percent) {
        const result = super.multiplyBy(percent);
        return new TokenAmount(this.token, result.raw);
    }
    reduceBy(percent) {
        const result = super.reduceBy(percent);
        return new TokenAmount(this.token, result.raw);
    }
    /**
     * Divides this TokenAmount by a raw integer.
     * @param other
     * @returns
     */
    divideByInteger(other) {
        return new TokenAmount(this.token, this.toU64().div(new bn_js_1.default((0, token_math_1.parseBigintIsh)(other).toString())));
    }
    /**
     * Formats the token amount with units and decimal adjustment, e.g. "100.42 SOL"
     * @returns
     */
    formatUnits() {
        return `${this.toExact()} ${this.token.symbol}`;
    }
    /**
     * String representation of this token amount.
     */
    toString() {
        return `TokenAmount[Token=(${this.token.toString()}), amount=${this.toExact()}`;
    }
    /**
     * JSON representation of the token amount.
     */
    toJSON() {
        return {
            _isTA: true,
            mint: this.token.mintAccount.toString(),
            uiAmount: this.toExact(),
        };
    }
    /**
     * Converts this to the raw u64 used by the SPL library
     * @returns
     */
    toU64() {
        return new spl_token_1.u64(this.raw.toString());
    }
}
exports.TokenAmount = TokenAmount;
//# sourceMappingURL=tokenAmount.js.map